import React from 'react'
import { version } from '../../../../config'
import './styles/Version.css'

const Version = () => (
  <div className="version-container">
    <p className="version">Version: {version}</p>
  </div>
)

export default Version



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Version/index.jsx